export default function assessmentTestRoutes(options = { isSAT: false }) {
    // Also compatible for SAT Module
    const routeNamePrefix = options.isSAT ? "sat." : ""
    const routePrefix = options.isSAT ? "/sat" : ""
    const pathPrefix = options.isSAT ? "SAT/" : "components/"
    return [
        {
            path: `${routePrefix}/questions`,
            name: `${routeNamePrefix}questions`,
            component: () => import(`../${pathPrefix}Questions.vue`),
            children: [
                {
                    path: "create",
                    component: () => import(`../${pathPrefix}Questions.vue`),
                    name: `${routeNamePrefix}question.create`,
                    meta: { is_protected: true },
                },
                {
                    path: "create/bulk",
                    component: () => import(`../${pathPrefix}question/bulk_create.vue`),
                    name: `${routeNamePrefix}question.create.bulk`,
                    meta: { is_protected: true },
                },
                {
                    path: "edit/:questionId",
                    component: () => import(`../${pathPrefix}Questions.vue`),
                    name: `${routeNamePrefix}question.edit`,
                    meta: { is_protected: true },
                },
                {
                    path: "index",
                    component: () => import(`../${pathPrefix}Questions.vue`),
                    name: `${routeNamePrefix}question.index`,
                    meta: { is_protected: true },
                },
            ],
            meta: { is_protected: true },
        },
        {
            path: `${routePrefix}/my-courses`,
            alias: `${routePrefix}/my-subjects`,
            name: `${routeNamePrefix}my-courses`,
            component: () => import(`../${pathPrefix}MyCourses.vue`),
            children: [
                {
                    path: "create",
                    component: () => import(`../${pathPrefix}MyCourses.vue`),
                    name: `${routeNamePrefix}course.create`,
                    meta: { is_protected: true },
                },
                {
                    path: "edit/:bookId",
                    component: () => import(`../${pathPrefix}MyCourses.vue`),
                    name: `${routeNamePrefix}course.edit`,
                    meta: { is_protected: true },
                },
                {
                    path: "edit/:bookId/additional-resources",
                    component: () => import(`../${pathPrefix}MyCourses.vue`),
                    name: `${routeNamePrefix}course.edit.additional_resources`,
                    meta: { is_protected: true },
                },
                {
                    path: ":bookId/topics",
                    name: `${routeNamePrefix}course.topics`,
                    component: () => import(`../${pathPrefix}MyCourses.vue`),
                },
                {
                    path: ":bookId/topics/:topicId",
                    name: `${routeNamePrefix}course.topics.synopsis`,
                    component: () => import(`../${pathPrefix}MyCourses.vue`),
                },
                {
                    path: ":bookId/topic/:topicId",
                    name: `${routeNamePrefix}course.topic.view`,
                    component: () => import(`../${pathPrefix}MyCourses.vue`),
                },
                {
                    path: ":bookId/topics/sub-topic/:topicId",
                    name: `${routeNamePrefix}course.topics.start`,
                    component: () => import(`../${pathPrefix}MyCourses.vue`),
                },
                // why eody static pages
            ],
            meta: { is_protected: true },
        },
    ]
}
